import { mapProductPrice, RawProductPrice } from '~/Api/Product';
import Price from '~/utils/Price/Price';

import CalculatedPrice from './CalculatedPrice';
import ExFactoryReferencePrice from './ExFactoryReferencePrice';

export interface RawExFactoryReferencePrice {
	sourcePrice: RawProductPrice;
	calculatedPrice: {
		type: string;
		description: string;
		sourceCurrencyPrice: { value: string; currency: string };
		targetCurrencyPrice: { value: string; currency: string };
	};
	selected: boolean;
}

export default function mapExFactoryReferencePrice(
	exFactoryReferencePrice: RawExFactoryReferencePrice
): ExFactoryReferencePrice {
	const {
		sourcePrice,
		calculatedPrice,
		calculatedPrice: { sourceCurrencyPrice, targetCurrencyPrice },
		selected,
	} = exFactoryReferencePrice;

	return new ExFactoryReferencePrice(
		mapProductPrice(sourcePrice),
		new CalculatedPrice(
			calculatedPrice.type,
			calculatedPrice.description,
			new Price(sourceCurrencyPrice.value, sourceCurrencyPrice.currency),
			new Price(targetCurrencyPrice.value, targetCurrencyPrice.currency)
		),
		selected
	);
}
